import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { AprovacaoListAction, AprovacaoAprovaAction } from '../../../actions/EspacoTecaActions';
import { Dropdown, Checkbox, Button, Card, Image, Grid, Tab } from 'semantic-ui-react';

function Aprovacao(props) {
    const { AprovacaoListAction, aprovacaoList, userid, isLoadingAprovacaoSend, AprovacaoAprovaAction, aprovacaoListLoading } = props;

    const [formState, setFormState] = useState({});
    const [errors, setErrors] = useState({}); // <- erros por idmidia
    const [loadingId, setLoadingId] = useState(null);
    const [loadingSimNao, setLoadingSimNao] = useState(null);

    useEffect(() => {
        AprovacaoListAction();
    }, [AprovacaoListAction]);

    const handleChange = (id, field, value) => {
        setFormState(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                [field]: value
            }
        }));
        // se alterar o dropdown, remove o erro
        if (field === "tipoMidia") {
            setErrors(prev => ({ ...prev, [id]: null }));
        }
    };

    const handleAction = (acao, idmidia) => {
        const dadosMidia = formState[idmidia] || {};

        if (!dadosMidia.tipoMidia) {
            setErrors(prev => ({ ...prev, [idmidia]: "Selecione o tipo da mídia" }));
            return;
        }

        setLoadingId(idmidia);
        setLoadingSimNao(acao)
        const data = {
            idmidia: idmidia,
            aprovado: acao,
            tipomidia: dadosMidia.tipoMidia,
            ecommerce: dadosMidia.ecommerce ? 1 : 0,
            fabricante: dadosMidia.fabricante ? 1 : 0,
            user: userid
        }
        AprovacaoAprovaAction(data).finally(() => {
            setLoadingId(null); // <- limpa loading depois da resposta
            setLoadingSimNao(null)
        });

    };

    const tipoMidiaOptions = [
        { key: 'fundo', text: 'Fundo Branco', value: 1 },
        { key: 'instalado', text: 'Produto Instalado', value: 2 },
        { key: 'regua', text: 'Régua', value: 3 },
        { key: 'acessorios', text: 'Acessórios', value: 4 },
        { key: 'IA', text: 'I.A', value: 5 },
        { key: 'avulso', text: 'Produto Avulso', value: 6 }
    ];

    return (
        <Tab.Pane loading={aprovacaoListLoading}>
            <div style={{ padding: '20px' }}>
                <h2>Aprovação de Mídias</h2>
                <Grid stackable>
                    {aprovacaoList?.map((item) => (
                        <Grid.Row key={item.idmidia} columns={2} style={{ marginBottom: '20px' }}>
                            {/* Mídia lado esquerdo */}
                            <Grid.Column width={6}>
                                {item.url.endsWith('.mp4') ? (
                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                        <video
                                            width="100%"
                                            height="180"
                                            controls
                                            style={{ objectFit: 'cover', cursor: 'pointer' }}
                                        >
                                            <source src={item.url} type="video/mp4" />
                                            Seu navegador não suporta vídeo.
                                        </video>
                                    </a>
                                ) : (
                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                        <Image
                                            src={item.url}
                                            alt={item.url}
                                            size="medium"
                                            bordered
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </a>
                                )}
                            </Grid.Column>

                            {/* Informações lado direito */}
                            <Grid.Column width={10}>
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>({item.sku}) {item.nomeprod} </Card.Header>
                                        <Card.Meta>
                                            Enviado por: {item.user} em {new Date(item.dtupload).toLocaleString('pt-BR')}
                                        </Card.Meta>
                                        <div>Observação: {item.observation ? item.observation : 'Esta mídia não contém observações.'}</div>
                                        <div style={{ marginTop: '10px' }}>
                                            <Dropdown
                                                placeholder="Tipo da mídia"
                                                selection
                                                options={tipoMidiaOptions}
                                                value={formState[item.idmidia]?.tipoMidia || item.tipomidia || null}
                                                onChange={(e, { value }) =>
                                                    handleChange(item.idmidia, 'tipoMidia', value)
                                                }
                                                error={!!errors[item.idmidia]} // <- deixa o campo vermelho
                                            />
                                            {errors[item.idmidia] && (
                                                <div style={{ color: 'red', marginTop: '5px' }}>
                                                    {errors[item.idmidia]}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ marginTop: '10px' }}>
                                            <Checkbox
                                                label="E-commerce"
                                                checked={formState[item.idmidia]?.ecommerce || false}
                                                onChange={(e, { checked }) =>
                                                    handleChange(item.idmidia, 'ecommerce', checked)
                                                }
                                            />
                                        </div>

                                        <div style={{ marginTop: '10px' }}>
                                            <Checkbox
                                                label="Fabricante"
                                                checked={formState[item.idmidia]?.fabricante || false}
                                                onChange={(e, { checked }) =>
                                                    handleChange(item.idmidia, 'fabricante', checked)
                                                }
                                            />
                                        </div>

                                        <div style={{ marginTop: '15px' }}>
                                            <Button
                                                color="green"
                                                onClick={() => handleAction(1, item.idmidia)}
                                                loading={isLoadingAprovacaoSend && loadingId === item.idmidia && loadingSimNao === 1}
                                                disabled={isLoadingAprovacaoSend}
                                            >
                                                Sim
                                            </Button>
                                            <Button
                                                color="red"
                                                onClick={() => handleAction(2, item.idmidia)}
                                                style={{ marginLeft: '10px' }}
                                                loading={isLoadingAprovacaoSend && loadingId === item.idmidia && loadingSimNao === 2}
                                                disabled={isLoadingAprovacaoSend}
                                            >
                                                Não
                                            </Button>
                                        </div>
                                    </Card.Content>
                                </Card>
                            </Grid.Column>
                        </Grid.Row>
                    ))}
                </Grid>
            </div>
        </Tab.Pane>

    );
}

const mapStateToProps = (state) => ({
    aprovacaoList: state.EspacoTecaReducer.aprovacaoList,
    userid: state.LoginReducer.userid,
    isLoadingAprovacaoSend: state.EspacoTecaReducer.isLoadingAprovacaoSend,
    aprovacaoListLoading: state.EspacoTecaReducer.aprovacaoListLoading,
});

export default withRouter(
    connect(mapStateToProps, { AprovacaoListAction, AprovacaoAprovaAction })(Aprovacao)
);
